import isEmpty from "lodash/isEmpty";
const createOptInsUpdate = (optIns = {}) => {
  if (isEmpty(optIns)) {
    return void 0;
  }
  return Object.keys(optIns).reduce(
    (m, optInName) => ({
      ...m,
      [optInName]: {
        value: optIns[optInName]?.checked ?? false,
        uiType: "checkbox",
        literalText: optIns[optInName]?.label ?? ""
      }
    }),
    {}
  );
};
export {
  createOptInsUpdate
};
//# sourceMappingURL=create-opt-in-updates.js.map
